import React, { useState } from 'react';
import RawDataModal from 'components/ChartContainer/components/RawDataModal/RawDataModal';
import ExportMenuContainer from 'components/ExportMenu/ExportMenuContainer';
import ExportMenuButton from 'components/ExportMenu/ExportMenuButton';
import { usePngExportModalContext } from 'components/ExportMenu/context/PngExportModal/PngExportModalContext';
import Loading from 'components/Loading';

import { styled } from '@mui/material/styles';
import { Box, SxProps, Theme } from '@mui/material';
import { useExportToFileFromMetricsDimensionsAndFilters } from 'routes/Explore/hooks/exportToFile';
import { ChartSettingsT } from 'business/definitions';
import useGetDashboardFilters from 'components/QueryPerimeter/hooks/useGetDashboardFilters';
import useGetDashboard from 'routes/Explore/hooks/useGetDashboard';
import { getPublicToken } from 'components/QueryPerimeter/hooks/useGetTreeData';
import { useParams } from 'react-router-dom';

const StyLoader = styled(Box, {
    name: 'StyLoader',
})({
    justifyContent: 'center',
    display: 'flex',
    height: '38px',
    alignItems: 'center',
});

type Props = {
    chartTitle: string;
    disableDashboardFilters: boolean;
    queryMetrics: SentenceMetricT[];
    queryDimensions: QueryDimensionT[];
    queryFilters: SentenceFilterT[];
    settings: ChartSettingsT;
    isIconButton?: boolean;
    buttonStyles?: SxProps<Theme>;
    columns?: string[];
    vizType?: string;
};

const GridChartExportMenu = ({
    chartTitle,
    disableDashboardFilters,
    queryMetrics,
    queryDimensions,
    queryFilters,
    isIconButton = true,
    buttonStyles = null,
    settings,
    columns,
    vizType,
}: Props): JSX.Element => {
    const [showRawDataModal, setShowRawDataModal] = useState(false);
    const { slug: slugParam } = useParams();
    const publicToken = getPublicToken();
    const { data: dashboard } = useGetDashboard(slugParam, publicToken);
    const { data: dashboardFilters, isLoading: isGetDashboardFiltersLoading } =
        useGetDashboardFilters(dashboard);

    const { setShowPngExport } = usePngExportModalContext();
    const { exportToFile, isExporting } =
        useExportToFileFromMetricsDimensionsAndFilters(
            chartTitle,
            queryMetrics,
            queryDimensions,
            queryFilters,
            settings,
            columns,
            vizType,
            !dashboardFilters || disableDashboardFilters
                ? []
                : dashboardFilters,
        );

    if (isExporting)
        return buttonStyles ? (
            <StyLoader sx={buttonStyles}>
                <Loading small />
            </StyLoader>
        ) : (
            <Loading small />
        );

    const menuComponent = isIconButton ? (
        <ExportMenuContainer
            exportTableData={() => exportToFile('csv')}
            exportExcelData={() => exportToFile('xlsx')}
            exportPng={() => setShowPngExport(true)}
        />
    ) : (
        <ExportMenuButton
            exportTableData={() => exportToFile('csv')}
            exportExcelData={() => exportToFile('xlsx')}
            exportPng={() => setShowPngExport(true)}
            buttonStyles={buttonStyles}
        />
    );
    return (
        <>
            {isGetDashboardFiltersLoading ? <Loading /> : menuComponent}
            {showRawDataModal && (
                <RawDataModal
                    show={showRawDataModal}
                    metrics={queryMetrics}
                    dimensions={queryDimensions}
                    filters={queryFilters}
                    closeModal={() => {
                        setShowRawDataModal(false);
                    }}
                    chartTitle={chartTitle}
                    columns={[]}
                    extraFilters={[]}
                />
            )}
        </>
    );
};

export default GridChartExportMenu;
